
import { useNavigate, useLocation } from 'react-router-dom';
import GlobalError from '../components/GlobalError';
import { useSnackbar } from '../contexts/SnackbarProvider';
import useDataFetch from '../hooks/useDataFetch';
import useDataSelect from '../hooks/useDataSelect';
import { getFields, searchFields } from '../utils/fields';
import { formatDateTime, formatCurrency } from '../utils/format';
import SearchForm from '../components/SearchForm';
import TableView from '../components/TableView';
import Pagination from '../components/Pagination';
import RelatedMenu from '../components/RelatedMenu';
import CsvUploadButtonOrder from '../components/CsvUploadButtonOrder';
import { Paper, Button, Link, Typography } from "@mui/material";
const OrdersPage = ({ hasLimit }) => {
  const { showSnackbar } = useSnackbar();
  const navigate = useNavigate();
  const location = useLocation();

  const initialOrderStatus = location.state?.filterStatus
    ? (typeof location.state.filterStatus === 'string'
      ? location.state.filterStatus.split(',').map(Number) // '2,3' → [2,3]
      : [location.state.filterStatus])
    : []; // デフォルト

  const { dataset: orderStatuses } = useDataSelect('/order/order-statuses');
  const {
    dataset,
    error,
    currentPage,
    totalPages,
    searchQuery,
    handleSearchChange,
    handleSearchSubmit,
    handleClearSearch,
    handlePageChange,
  } = useDataFetch('/order', { order_numbers: '', client_name: '', dates: '', order_status: initialOrderStatus });

  const handleRowClick = async (item) => {
    navigate(`/orders/${item.order_id}`);
  };

  // 検索フィールド定義
  const fieldsToInclude = ['dates', 'order_numbers', 'client_name'];
  let searchItems = getFields(searchFields, fieldsToInclude);
  searchItems = [
    ...searchItems,
    {
      name: 'order_status',
      type: 'select',
      label: 'ステータス',
      options: orderStatuses.map((item) => ({
        value: item.order_status_id,
        label: item.order_status_name,
      }))
    },
  ];

  const columns = [
    {
      label: '注文日',
      accessor: 'order_date',
      format: (date) => formatDateTime(date),
      width: '140px',
    },
    {
      label: '注文番号',
      accessor: 'order_number',
      render: (item) => (
        <Link
          component="button"
          onClick={() => handleRowClick(item)}>
          {item.order_number}
        </Link>
      ),
      width: '140px',
    },
    {
      label: 'ステータス',
      accessor: 'order_status_name',
      width: '140px',
    },
    {
      label: '金額',
      accessor: 'total_amount',
      render: (item) => (
        <>
          {formatCurrency(item.total_amount)}<br />
          <Typography variant="caption">税込 {formatCurrency(item.total_amount_including_tax)}</Typography>
        </>
      ),
      width: '140px',
    },
    {
      label: '会社名＋事業所名',
      accessor: 'client_name',
      render: (item) => (
        <Typography>
          {item.client_name} {item.branch_name}
        </Typography>
      ),
      width: '350px',
    },
    {
      label: '',
      render: (item) => (
        <Button
          size="small"
          variant="outlined"
          onClick={() => handleRowClick(item)}>
          詳細
        </Button>
      ),
      width: '50px',
    },
  ];
  const links = [
    { path: '/orders/new', label: '新規注文作成', icon: 'library_add' },
    ...(hasLimit('max_picking_devices') ? [{ path: '/picking', label: 'ピッキング処理', icon: 'devices' }] : []),
    { path: '/orders/complete', label: '注文完了処理', icon: 'library_add_check' }
  ];

  if (error) return <GlobalError errorMessage={error} />;
  return (
    <>
      <Typography variant="h1" component="h1">注文一覧</Typography>
      <div className='grid2-2_1'>
        {/* 検索フォーム */}
        <SearchForm
          searchQuery={searchQuery}
          searchFields={searchItems}
          handleSearchChange={handleSearchChange}
          handleSearchSubmit={handleSearchSubmit}
          handleClearSearch={handleClearSearch}
        />
        <RelatedMenu links={links}>
          {hasLimit('csv_order_upload') &&
            <CsvUploadButtonOrder buttonStyle="relatedmenu font-m" />
          }
        </RelatedMenu>
      </div>
      <Paper variant='section'>
        <TableView dataset={dataset} columns={columns} keyColumn="order_id" />
        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={handlePageChange}
        />
      </Paper>
    </>
  );
};


export default OrdersPage;
